<template>
  <home-section
    :title="section.title"
    :subtitle="section.subtitle"
    :loading="loading"
    :error="error"
    :is-empty="!items.length"
    variant="ranking"
    skeleton-variant="ranking"
    :skeleton-count="4"
    @retry="$emit('retry', section)"
  >
    <home-ranking-rail :items="items" :label="section.title" :show-views="section.showViews !== false" />
  </home-section>
</template>

<script>
import HomeSection from "./HomeSection.vue";
import HomeRankingRail from "@/components/home/rails/HomeRankingRail.vue";

export default {
  name: "HomeRankingSection",
  components: { HomeSection, HomeRankingRail },
  props: {
    section: { type: Object, required: true },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
};
</script>
